const consultaCep = async (cep) => {
    // Remove caracteres não numéricos
    const cleanCep = (cep || '').replace(/\D/g, '');
    if (cleanCep.length !== 8) {
        throw new Error('CEP inválido');
    }

    const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
    const data = await response.json();

    if (data.erro) {
        throw new Error('CEP não encontrado');
    }

    // Retorna no formato do campo endereco do modelo Tenant (objeto único)
    return {
        CEP: data.cep || '',
        logradouro: data.logradouro || '',
        numero: '', // número deve ser preenchido pelo usuário
        complemento: data.complemento || '',
        bairro: data.bairro || '',
        municipio: data.localidade || '',
        UF: data.uf || ''
    };
};

export default consultaCep;